var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 12.5625V1.875H9.1875V12.5625H1.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 5.8125V1.875H22.125V5.8125H14.8125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 22.125V11.4375H22.125V22.125H14.8125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 22.125V18.1875H9.1875V22.125H1.875Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9375 0.75C12.9375 0.335786 13.2733 0 13.6875 0H23.25C23.6642 0 24 0.335787 24 0.75V6.9375C24 7.35171 23.6642 7.6875 23.25 7.6875H13.6875C13.2733 7.6875 12.9375 7.35171 12.9375 6.9375V0.75ZM14.8125 1.875V5.8125H22.125V1.875H14.8125ZM12.9375 10.3125C12.9375 9.89829 13.2733 9.5625 13.6875 9.5625H23.25C23.6642 9.5625 24 9.89829 24 10.3125V23.25C24 23.6642 23.6642 24 23.25 24H13.6875C13.2733 24 12.9375 23.6642 12.9375 23.25V10.3125ZM14.8125 11.4375V22.125H22.125V11.4375H14.8125Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3125 0H0.75C0.335786 0 0 0.335786 0 0.75V13.6875C0 14.1017 0.335786 14.4375 0.75 14.4375H10.3125C10.7267 14.4375 11.0625 14.1017 11.0625 13.6875V0.75C11.0625 0.335787 10.7267 0 10.3125 0ZM1.875 1.875V12.5625H9.1875V1.875H1.875Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3125 16.3125H0.75C0.335786 16.3125 0 16.6483 0 17.0625V23.25C0 23.6642 0.335786 24 0.75 24H10.3125C10.7267 24 11.0625 23.6642 11.0625 23.25V17.0625C11.0625 16.6483 10.7267 16.3125 10.3125 16.3125ZM1.875 18.1875V22.125H9.1875V18.1875H1.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.d2c5a22045f9f6d9b53f87820681ed60.svg";
export { ForwardRef as ReactComponent };